import {inject, injectable} from "inversify";
import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {Team} from "../../team/entity";
import AIServiceProvider from "@/modules/ai/services/AIServiceProvider";
import {BeforeMatchEvent} from "@/modules/match/events/BeforeMatchEvent";

@injectable()
export default class LineupEventSubscriber implements EventSubscriber {
  constructor(
    @inject(AIServiceProvider) private aIServiceProvider: AIServiceProvider,
  ) {
  }

  priority(): number {
    return 100;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: BeforeMatchEvent, callback: this.onBeforeMatchEvent},
    ];
  }

  public async onBeforeMatchEvent(event: BeforeMatchEvent) {
    await [
      event.match.homeTeam,
      event.match.awayTeam,
    ].forEachAsync(async (team: Team) => {
      if (team.user) {
        return;
      }

      await this.aIServiceProvider.getLineupper(team.aiQualityLevel).lineup(team);
    });
  }
}
